export const fileTextIcon = [
  "24 24",
  `     
         <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11,1H3A2,2,0,0,0,1,3V19a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2V7Zm0,0V7h6m-4,5H5m8,4H5M7,8H5"/>
          
            `,
];
